module.exports = __webpack_public_path__ + "img/pro_two_8.2d1e8282.jpg";